module.exports = __webpack_public_path__ + "static/media/CyberFinish.9851d300.jpg";